import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "futureprospective",
  inputs: [
    {
      name: "home_country",
      label: "Home Country",
      placeholder: "India",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      // description: "Please write your current country for best results.",
      required: true,
    },
    {
      name: "course_selected",
      label: "Course ",
      placeholder: "Mtech. CSE",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "field",
      label: "Field",
      placeholder: "Web Development Machine-Learning ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: false,
    },
    {
      name: "expected_salary",
      label: "Expected Salary",
      placeholder: "40k US dollars",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 200,
      assistance: true,
      inputDependencies: ["course_selected"],
      helpType: "future_scope",
      required: false,
    },
    {
      name: "companies",
      label: "Companies",
      placeholder: "IBM Infosys Wipro",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 400,
      assistance: true,
      inputDependencies: ["course_selected"],
      helpType: "future_scope",
      required: false,
    },
    {
      name: "roles",
      label: "Posts",
      placeholder: "Software Developer",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 400,
      assistance: true,
      inputDependencies: ["course_selected"],
      helpType: "future_scope",
      required: false,
    },
  ],
};

export default formFields;
